import React from 'react'
import {graphql} from 'gatsby'
import Layout from './../components/layout'
import WorkSubNav from './../components/work-sub-nav'
import WorkSubHeading from './../components/work-sub-heading'
import GalleryGrid from './../components/gallery-grid'
// import {RA_SOLO_SHOW_IMAGES} from './../constants/ra-solo-show-images'
import WorkIntroText from './../components/work-intro-text'
import WorkFooterText from './../components/work-footer-text'
import ScrollToTop from './../components/scroll-to-top'

export default props => {
  const {data} = props
  const prismicData = {
    limitedEditionPrintsAreAvailable: data.prismicLimitedEditionPrintsPage.data.currently_available,
    introText: data.prismicRaSoloShowPage.data.intro_text.html,
    footerText: data.prismicRaSoloShowPage.data.footer_text.html,
    pageHeading: data.prismicRaSoloShowPage.data.page_heading.text,
    images: data.prismicRaSoloShowPage.data.images,
  }

  const RA_SOLO_SHOW_IMAGES = prismicData.images.map(item => {
    return {
      title: item.image_title.text,
      fullUrl: item.image.url,
      thumbnailUrl: item.image.thumbnails.w400.url,
      orientation: item.image_orientation,
      supplementary_info: '',
    }
  })

  return (
    <Layout pageName="ra-solo-show" documentTitlePrefix={`${prismicData.pageHeading} | Work`}>
      <WorkSubNav
        currentPageName="ra-solo-show"
        limitedEditionPrintsAreAvailable={prismicData.limitedEditionPrintsAreAvailable}
      />
      <WorkSubHeading headingText={prismicData.pageHeading} />
      <WorkIntroText html={prismicData.introText} />
      <GalleryGrid staticImagesFolderName="ra-solo-show" imageData={RA_SOLO_SHOW_IMAGES} classModifier="work" />
      <WorkFooterText html={prismicData.footerText} />
      <ScrollToTop />
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    prismicLimitedEditionPrintsPage {
      data {
        currently_available
      }
    }
    prismicRaSoloShowPage {
      data {
        page_heading {
          text
        }
        footer_text {
          html
        }
        intro_text {
          html
        }
        images {
          image_title {
            text
          }
          image {
            url(imgixParams: {q: 70, h: 1400, fit: "scale"})
            thumbnails {
              w400 {
                url(imgixParams: {q: 50})
              }
            }
          }
          image_orientation
        }
      }
    }
  }
`
